import { connect } from 'react-redux'
import LicenseAccessAdd from '../../components/LicenseAccess/LicenseAccessAdd'
import {addLicense, addUser, getUserEmails} from "../../actions/index";



const mapStateToProps = state => {
    return {
        emails: state.users.emails
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        addLicense: (data) => {
            return dispatch(addLicense(data));
        },

    }
};


export default connect(
    mapStateToProps,
    mapDispatchToProps

)(LicenseAccessAdd);
